import isString from '../../../core/util/isString';

const updateSearchParams = (
    searchParams: URLSearchParams,
    values: Record<string, string | undefined | string[] | number | boolean>
) => {
    const newSearchParams = new URLSearchParams(searchParams);
    for (const key of Object.keys(values)) {
        const value = values[key];
        newSearchParams.delete(key);
        if (Array.isArray(value)) {
            for (const item of value) {
                newSearchParams.append(key, item);
            }
        } else if (isString(value)) {
            newSearchParams.set(key, value);
        } else if (value !== undefined) {
            newSearchParams.set(key, value.toString());
        }
    }
    return newSearchParams;
};

export default updateSearchParams;
